
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, TablePagination, Typography, Button, Grid, CircularProgress, Switch, IconButton, Dialog, DialogActions, DialogContent, TextField, FormControl, InputLabel, MenuItem, Select, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogContentStyle, DialogActionsStyle } from "../../styles/DialogStyle";

import { ActualizarTipoAudiencia, AgregarTipoAudiencia, TipoAudiencia } from "../../connections/catalogos/TipoAudienciaConnection";
import { ObtenerMateria } from "../../connections/catalogos/MateriaConnection";

import { TipoAudienciaProps } from "../../interfaces/catalogos/TipoAudienciaInterface";
import { MateriaProps } from "../../interfaces/catalogos/MateriaInterface";

export const TipoAudienciaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [tipoAudienciaArray, setTipoAudienciaArray] = useState<TipoAudienciaProps[]>([]);

    const [idTipoAudiencia, setIdTipoAudiencia] = useState(0);
    const [descripcion, setDescripcion] = useState('');
    const [referencia, setReferencia] = useState('');
    const [duracion, setDuracion] = useState(0);

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>([]);    

    const [plazoInicial, setPlazoInicial] = useState(0);
    const [plazoFinal, setPlazoFinal] = useState(0);

    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    
    const [loadingData, setLoadingData] = useState(true);

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const { filtro, setFiltro, dataFiltrada } = useFilter( tipoAudienciaArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async (checked: boolean, id: number) => {
    
        const TipoAudienciaSelected = tipoAudienciaArray.find((elem) => elem.idTipoAudiencia === id);

        if (TipoAudienciaSelected) {

            await ActualizarTipoAudiencia({ ...TipoAudienciaSelected, activo: checked }).then(resp => {

                if (resp.idTipoAudiencia) {

                    var newArray = tipoAudienciaArray.map((elem) => {

                        if (elem.idTipoAudiencia === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setTipoAudienciaArray(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                }

            });
        }

    }
     
    const handleGuardar = async () => {

        setLoading( true )

        if ( idTipoAudiencia !== 0 ) {

            const tipoAudiencia = tipoAudienciaArray.find( (row ) => row.idTipoAudiencia === idTipoAudiencia );

            const params: TipoAudienciaProps = {
                idTipoAudiencia: idTipoAudiencia,           
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: tipoAudiencia?.activo ?? false,
                idMateria: materia,
                duracion,
                plazoInicial,
                plazoFinal,
            };

            await ActualizarTipoAudiencia( params ).then( resp => {

                if( resp ) {

                    setTimeout(() => {

                        const newRows = tipoAudienciaArray.map( ( row ) => {

                            if ( row.idTipoAudiencia === idTipoAudiencia ) {

                                row.referencia = resp.referencia;
                                row.descripcion = descripcion;
                                row.idMateria = resp.idMateria;
                                row.materia = resp.materia;
                                row.duracion = resp.duracion;
                                row.plazoInicial = resp.plazoInicial;
                                row.plazoFinal = resp.plazoFinal;

                                return row;
                            }
                            
                            return row;                            
                        });

                        setTipoAudienciaArray(newRows);

                        setLoading(false);
                        setOpenModal(false);

                        dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }
        else {

            const params: TipoAudienciaProps = {
                idTipoAudiencia: 0,             
                idMateria: materia,
                referencia: referencia === '' ? 0 : parseInt(referencia),
                descripcion: descripcion.trim(),
                activo: true,
                duracion,
                plazoInicial,
                plazoFinal,
            };

            await AgregarTipoAudiencia( params ).then( resp => {

                if ( resp ) {

                    setTimeout(() => {

                        setTipoAudienciaArray([ ...tipoAudienciaArray, resp ]);

                        setLoading( false );
                        setOpenModal( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de audiencia correctamente', variant: 'success' })); 

                    }, 400);

                }

            });
        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setTipoAudienciaArray([]);

            await TipoAudiencia().then(resp => {

                setTimeout(() => {

                    setTipoAudienciaArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then(resp => {
                setMateriaArray(resp);
            });

        }

        Obtener();

    }, []);

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de audiencia' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ md: 6, xs: 12 }} textAlign={'start'}>

                    <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                        Regresar
                    </Button>

                </Grid>

                <Grid size={{ md: 6, xs: 12 }} textAlign={'end'}>

                    <Button
                        type="button"
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={ () => {
                            setIdTipoAudiencia( 0 );
                            setDescripcion( '' );                                                   
                            setReferencia( '' );     
                            setMateria( 0 );
                            setReferencia( '' );
                            setDuracion( 0 );
                            setPlazoInicial( 0 );
                            setPlazoFinal( 0 );

                            setOpenModal( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por descripción"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}> Descripción </TableCell>                                    
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}>  Materia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Referencia SAJI </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Duración <br /> (Minutos) </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Plazo inicial <br /> (Días) </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Plazo final <br /> (Días) </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idTipoAudiencia, descripcion, referencia, activo, idMateria, materia, duracion, plazoInicial, plazoFinal }) => (

                                    <TableRow key={idTipoAudiencia} >

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            {idTipoAudiencia}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            {materia?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { referencia ? <> ({ referencia }) </> : '' }
                                        </TableCell>    

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { duracion ?? 0 } min.
                                        </TableCell>    

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { plazoInicial ?? 0 } dia(s).
                                        </TableCell>    

                                        <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            { plazoFinal ?? 0 } dia(s).
                                        </TableCell>    

                                        <TableCell sx={{ textAlign: 'end' }}>
                                                                                
                                            <Switch 
                                                checked={ activo } 
                                                onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoAudiencia ) }
                                            />                                            
                                
                                            <IconButton 
                                                    color="primary" 
                                                    aria-label="edit" 
                                                    component="span" 
                                                    onClick={ () => {

                                                        setIdTipoAudiencia( idTipoAudiencia );
                                                        setDescripcion( descripcion );                                                   
                                                        setReferencia( referencia.toString() );     
                                                        setMateria( idMateria );
                                                        setDuracion( duracion ?? 0 );
                                                        setPlazoInicial( plazoInicial ?? 0 );
                                                        setPlazoFinal( plazoFinal ?? 0 );

                                                        setOpenModal( true );
                                                    }}
                                                >                                                        
                                                <EditIcon />
                                            </IconButton>  

                                        </TableCell>                                        

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" fontWeight={'bold'}> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center">

                                            <CircularProgress size={32} />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none' }}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: {dataFiltrada.length}
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none' }}
                                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                        colSpan={8}
                                        count={dataFiltrada.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}

                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}

                                        ActionsComponent={TablePaginationActions}

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog 
                maxWidth='sm' 
                open={openModal} 
                fullWidth={true}
            >

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Materia</InputLabel>

                                <Select                                 
                                    label="Materia"
                                    value={materia}
                                    onChange={ (e) => setMateria(e.target.value ?? 0) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray.map((elem) => (
                                            <MenuItem key={elem.idMateria} value={elem.idMateria}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>  

                        </Grid>                                                
                        
                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={'Referencia en SAJI'}
                                variant="outlined"                     
                                type='number'
                                value={ referencia }
                                onChange={ (e) => setReferencia(e.target.value) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={'Duración (Minutos)'}
                                variant="outlined"                     
                                type='number'
                                value={ duracion }
                                onChange={ (e) => setDuracion( parseInt( e.target.value ?? '0' )) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={'Plazo inicial (Días)'}
                                variant="outlined"                     
                                type='number'
                                value={ plazoInicial }
                                onChange={ (e) => setPlazoInicial( parseInt( e.target.value ?? '0' )) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>
                        
                        <Grid size={{ md: 4, xs: 12 }}>

                            <TextField
                                fullWidth
                                label={'Plazo final (Días)'}
                                variant="outlined"                     
                                type='number'
                                value={ plazoFinal }
                                onChange={ (e) => setPlazoFinal( parseInt( e.target.value ?? '0' )) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />

                        </Grid>
                        
                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={'Descripción'}
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}        
                            />
                            
                        </Grid>
                        
                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => setOpenModal( false ) }> Cancelar </Button>
                    <Button 
                        variant='contained' 
                        loading={ loading } 
                        disabled={ descripcion === '' || materia === 0 || ( referencia === '0' || referencia === '' ) } 
                        onClick={ handleGuardar } 
                    > 
                        Guardar 
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}